import { useState } from 'react';
export var useToggle = function useToggle() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _useState = useState(initialState),
      state = _useState[0],
      setState = _useState[1];

  var handlers = {
    on: function on() {
      return setState(true);
    },
    off: function off() {
      return setState(false);
    },
    toggle: function toggle() {
      return setState(function (oldState) {
        return !oldState;
      });
    },
    reset: function reset() {
      return setState(initialState);
    }
  };
  return [state, handlers];
};